// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Barlow-Light.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "BarlowLight";
  src: local("BarlowLight"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
}

.footer {
  background: #7ba7c2;
  width: 100vw;
}

.footer .footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
}

.footer-row {
  padding-left: 60px;
  padding-right: 60px;
  width: calc(100% - 120px);
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
}

.footer-title-section {
  width: 40%;
  color: #fcfcfc;
  margin-top: 60px;
  margin-bottom: 30px;
}

.footer-title-section .footer-logo {
  width: 80%;
}

.footer-title-section .footer-title-text {
  width: 80%;
  font-family: "BarlowLight";
  padding: 30px 0px;
}

.footer-col-section {
  width: 70%;
  flex-wrap: wrap;
  padding: 0px 0px 0px 60px;
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  margin-bottom: 30px;
}

.footer-col {
  color: #fcfcfc;
  width: 20%;
  padding-top: 60px;
}

.footer-col-title {
  font-family: "Barlow";
  margin-bottom: 24px;
}

.footer-col-item {
  font-family: "BarlowLight";
  list-style: none;
}

.footer-col-item .items {
  padding-bottom: 6px;
}

.footer-col-item .extra {
  color: rgba(236, 235, 230, 0.5);
}

.footer-company-info {
  width: 20%;
  color: #fcfcfc;
}

.footer-company-info .footer-company-info-group {
  padding-top: 30px;
}

.footer-company-info .telephone {
  padding-bottom: 30px;
}

.social-icon-group {
  display: flex;
  justify-content: flex-end;
  width: 80%;
  padding-bottom: 110px;
  align-items: flex-end;

}

.social-icon-group .icon-group {
  color: #fcfcfc;


}


.social-icon-group .icon-group:first-child .footer-social-text {
  border-right: 1px solid rgba(236, 235, 230, 0.5); 


}



.footer-social-text {
  margin-bottom: 24px;
  padding: 0px 12px;
}

.footer-social-icon {
  display: flex;
}

.social-icon-group .icon-group .social-icon {
  width: 24px;
  height: 24px;
  margin:0px  6px;

}

.social-icon {
  padding: 8px;
  border: 1px solid #fcfcfc;
  border-radius: 12px;
}

.copyright {
  margin-top: -80px;
  color: #fcfcfc;
  width: 100%;
  text-align: right;
  padding-bottom: 30px;
}

.footer-tnc {
  display: none;
}
.prestige .footer-social-text{
  color: #C8FCFF;
}
.prestige .footer-social-icon a svg{
  fill: #C8FCFF;
  border: 1px solid #C8FCFF;;
}
@media only screen and (max-device-width: 480px) {
  .footer-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 0px 30px;
  }

  .footer-title-section {
    width: 100%;
    color: #fcfcfc;
    margin-top: 0px;
    padding-top: 60px;
    margin-bottom: 30px;
    text-align: center;
  }

  .footer-title-text {
    display: block;
    width: 100% !important;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    padding: 30px 0px;
  }

  .footer-col {
    width: 50%;
    margin-top: 30px;
    padding-top: 0px;
  }

  .footer-col.Company {
    display: none;
  }

  .footer-company-info {
    width: 100%;
    display: flex;
    margin-bottom: 0px;
  }

  .footer-company-info .footer-company-info-group {
    width: 50%;
  }

  .items {
    width: 90%;
  }

  .social-icon-group {
    width: 100%;
    display: flex;
    margin-top: 30px;
  }

  .social-icon-group .icon-group {
    display: block;
    width: 50%;
    justify-content: flex-start;

  }
  .footer-social-text {
    padding: 0px 0px;
}
.social-icon-group .icon-group:first-child .footer-social-text {
  border-right: 1px solid rgba(236, 235, 230, 0);
}

  .social-icon-group .icon-group .social-icon {
    padding: 8px;
    color: #fcfcfc;
    border-radius: 10px;
    width: 18px !important;
    height: 18px !important;
    margin: 0px 3px;
  }

  .copyright {
    margin-top: -60px;
    width: 100%;
    text-align: left;
  }

  .copyright .right-reserved {
    display: none;
  }

  .footer-tnc {
    display: flex;
    align-items: center;
  }

  .footer-tnc li:first-child {
    padding-right: 12px;
  }

  .footer-tnc li a {
    color: #ecebe6;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/footer.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4EAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,gFAA2E;AAC7E;;AAEA;EACE,0BAA0B;EAC1B,iFAA2E;AAC7E;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,qBAAqB;EACrB,qBAAqB;;AAEvB;;AAEA;EACE,cAAc;;;AAGhB;;;AAGA;EACE,gDAAgD;;;AAGlD;;;;AAIA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;;AAEjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,UAAU;IACV,2BAA2B;;EAE7B;EACA;IACE,gBAAgB;AACpB;AACA;EACE,8CAA8C;AAChD;;EAEE;IACE,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"../fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"../fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowLight\";\n  src: local(\"BarlowLight\"), url(\"../fonts/Barlow-Light.woff\") format(\"woff\");\n}\n\n.footer {\n  background: #7ba7c2;\n  width: 100vw;\n}\n\n.footer .footer-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.footer-row {\n  padding-left: 60px;\n  padding-right: 60px;\n  width: calc(100% - 120px);\n  display: flex;\n  flex-wrap: wrap;\n  overflow: auto;\n}\n\n.footer-title-section {\n  width: 40%;\n  color: #fcfcfc;\n  margin-top: 60px;\n  margin-bottom: 30px;\n}\n\n.footer-title-section .footer-logo {\n  width: 80%;\n}\n\n.footer-title-section .footer-title-text {\n  width: 80%;\n  font-family: \"BarlowLight\";\n  padding: 30px 0px;\n}\n\n.footer-col-section {\n  width: 70%;\n  flex-wrap: wrap;\n  padding: 0px 0px 0px 60px;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 60px;\n  margin-bottom: 30px;\n}\n\n.footer-col {\n  color: #fcfcfc;\n  width: 20%;\n  padding-top: 60px;\n}\n\n.footer-col-title {\n  font-family: \"Barlow\";\n  margin-bottom: 24px;\n}\n\n.footer-col-item {\n  font-family: \"BarlowLight\";\n  list-style: none;\n}\n\n.footer-col-item .items {\n  padding-bottom: 6px;\n}\n\n.footer-col-item .extra {\n  color: rgba(236, 235, 230, 0.5);\n}\n\n.footer-company-info {\n  width: 20%;\n  color: #fcfcfc;\n}\n\n.footer-company-info .footer-company-info-group {\n  padding-top: 30px;\n}\n\n.footer-company-info .telephone {\n  padding-bottom: 30px;\n}\n\n.social-icon-group {\n  display: flex;\n  justify-content: flex-end;\n  width: 80%;\n  padding-bottom: 110px;\n  align-items: flex-end;\n\n}\n\n.social-icon-group .icon-group {\n  color: #fcfcfc;\n\n\n}\n\n\n.social-icon-group .icon-group:first-child .footer-social-text {\n  border-right: 1px solid rgba(236, 235, 230, 0.5); \n\n\n}\n\n\n\n.footer-social-text {\n  margin-bottom: 24px;\n  padding: 0px 12px;\n}\n\n.footer-social-icon {\n  display: flex;\n}\n\n.social-icon-group .icon-group .social-icon {\n  width: 24px;\n  height: 24px;\n  margin:0px  6px;\n\n}\n\n.social-icon {\n  padding: 8px;\n  border: 1px solid #fcfcfc;\n  border-radius: 12px;\n}\n\n.copyright {\n  margin-top: -80px;\n  color: #fcfcfc;\n  width: 100%;\n  text-align: right;\n  padding-bottom: 30px;\n}\n\n.footer-tnc {\n  display: none;\n}\n.prestige .footer-social-text{\n  color: #C8FCFF;\n}\n.prestige .footer-social-icon a svg{\n  fill: #C8FCFF;\n  border: 1px solid #C8FCFF;;\n}\n@media only screen and (max-device-width: 480px) {\n  .footer-row {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0px 30px;\n  }\n\n  .footer-title-section {\n    width: 100%;\n    color: #fcfcfc;\n    margin-top: 0px;\n    padding-top: 60px;\n    margin-bottom: 30px;\n    text-align: center;\n  }\n\n  .footer-title-text {\n    display: block;\n    width: 100% !important;\n    text-align: left;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 30px 0px;\n  }\n\n  .footer-col {\n    width: 50%;\n    margin-top: 30px;\n    padding-top: 0px;\n  }\n\n  .footer-col.Company {\n    display: none;\n  }\n\n  .footer-company-info {\n    width: 100%;\n    display: flex;\n    margin-bottom: 0px;\n  }\n\n  .footer-company-info .footer-company-info-group {\n    width: 50%;\n  }\n\n  .items {\n    width: 90%;\n  }\n\n  .social-icon-group {\n    width: 100%;\n    display: flex;\n    margin-top: 30px;\n  }\n\n  .social-icon-group .icon-group {\n    display: block;\n    width: 50%;\n    justify-content: flex-start;\n\n  }\n  .footer-social-text {\n    padding: 0px 0px;\n}\n.social-icon-group .icon-group:first-child .footer-social-text {\n  border-right: 1px solid rgba(236, 235, 230, 0);\n}\n\n  .social-icon-group .icon-group .social-icon {\n    padding: 8px;\n    color: #fcfcfc;\n    border-radius: 10px;\n    width: 18px !important;\n    height: 18px !important;\n    margin: 0px 3px;\n  }\n\n  .copyright {\n    margin-top: -60px;\n    width: 100%;\n    text-align: left;\n  }\n\n  .copyright .right-reserved {\n    display: none;\n  }\n\n  .footer-tnc {\n    display: flex;\n    align-items: center;\n  }\n\n  .footer-tnc li:first-child {\n    padding-right: 12px;\n  }\n\n  .footer-tnc li a {\n    color: #ecebe6;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
